// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"862e8b95","127":"8946050a","326":"cdf6d22b","327":"3267dc18","467":"cce8e7b3"}[chunkId] + ".chunk.js";
};